/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Banking account number is a string of 5 to 17 alphanumeric values for representing an generic account number */
  AccountNumber: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: { input: any; output: any; }
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: { input: any; output: any; }
  /** A country name (short name) as defined by ISO 3166-1 */
  CountryName: { input: any; output: any; }
  /** A field whose value conforms to the standard cuid format as specified in https://github.com/ericelliott/cuid#broken-down */
  Cuid: { input: any; output: any; }
  /** A field whose value is a Currency: https://en.wikipedia.org/wiki/ISO_4217. */
  Currency: { input: any; output: any; }
  /** A field whose value conforms to the standard DID format as specified in did-core: https://www.w3.org/TR/did-core/. */
  DID: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: string; output: string; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** A field whose value conforms to the standard DeweyDecimal format as specified by the OCLC https://www.oclc.org/content/dam/oclc/dewey/resources/summaries/deweysummaries.pdf */
  DeweyDecimal: { input: any; output: any; }
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  Duration: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any; }
  /**
   * The implementation for this scalar is provided by the
   * 'GraphQLUpload' export from the 'graphql-upload' package
   */
  FileUpload: { input: File; output: File; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  GUID: { input: any; output: any; }
  /** A GeoJSON object as defined by RFC 7946: https://datatracker.ietf.org/doc/html/rfc7946 */
  GeoJSON: { input: any; output: any; }
  /** A field whose value is a CSS HSL color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSL: { input: any; output: any; }
  /** A field whose value is a CSS HSLA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSLA: { input: any; output: any; }
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: { input: any; output: any; }
  /** A field whose value is a hexadecimal: https://en.wikipedia.org/wiki/Hexadecimal. */
  Hexadecimal: { input: any; output: any; }
  /** A field whose value is an International Bank Account Number (IBAN): https://en.wikipedia.org/wiki/International_Bank_Account_Number. */
  IBAN: { input: any; output: any; }
  /** A field whose value is either an IPv4 or IPv6 address: https://en.wikipedia.org/wiki/IP_address. */
  IP: { input: any; output: any; }
  /** A field whose value is an IPC Class Symbol within the International Patent Classification System: https://www.wipo.int/classifications/ipc/en/ */
  IPCPatent: { input: any; output: any; }
  /** A field whose value is a IPv4 address: https://en.wikipedia.org/wiki/IPv4. */
  IPv4: { input: any; output: any; }
  /** A field whose value is a IPv6 address: https://en.wikipedia.org/wiki/IPv6. */
  IPv6: { input: any; output: any; }
  /** A field whose value is a ISBN-10 or ISBN-13 number: https://en.wikipedia.org/wiki/International_Standard_Book_Number. */
  ISBN: { input: any; output: any; }
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  ISO8601Duration: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: unknown; output: unknown; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: { input: any; output: any; }
  /** A field whose value conforms to the Library of Congress Subclass Format ttps://www.loc.gov/catdir/cpso/lcco/ */
  LCCSubclass: { input: any; output: any; }
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: { input: any; output: any; }
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: { input: any; output: any; }
  /** A local date-time string (i.e., with no associated timezone) in `YYYY-MM-DDTHH:mm:ss` format, e.g. `2020-01-01T00:00:00`. */
  LocalDateTime: { input: any; output: any; }
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`.  This scalar is very similar to the `LocalTime`, with the only difference being that `LocalEndTime` also allows `24:00` as a valid value to indicate midnight of the following day.  This is useful when using the scalar to represent the exclusive upper bound of a time block. */
  LocalEndTime: { input: any; output: any; }
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`. */
  LocalTime: { input: any; output: any; }
  /** The locale in the format of a BCP 47 (RFC 5646) standard string */
  Locale: { input: any; output: any; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: { input: any; output: any; }
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: { input: any; output: any; }
  /** A field whose value is a IEEE 802 48-bit MAC address: https://en.wikipedia.org/wiki/MAC_address. */
  MAC: { input: any; output: any; }
  /** Floats that will have a value less than 0. */
  NegativeFloat: { input: any; output: any; }
  /** Integers that will have a value less than 0. */
  NegativeInt: { input: any; output: any; }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: any; output: any; }
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: { input: any; output: any; }
  /** Floats that will have a value of 0 or less. */
  NonPositiveFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or less. */
  NonPositiveInt: { input: any; output: any; }
  /** A field whose value conforms with the standard mongodb object ID as described here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId. Example: 5e5677d71bdc2ae76344968c */
  ObjectID: { input: any; output: any; }
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: { input: any; output: any; }
  /** A field whose value is a valid TCP port within the range of 0 to 65535: https://en.wikipedia.org/wiki/Transmission_Control_Protocol#TCP_ports */
  Port: { input: any; output: any; }
  /** Floats that will have a value greater than 0. */
  PositiveFloat: { input: any; output: any; }
  /** Integers that will have a value greater than 0. */
  PositiveInt: { input: any; output: any; }
  /** A field whose value conforms to the standard postal code formats for United States, United Kingdom, Germany, Canada, France, Italy, Australia, Netherlands, Spain, Denmark, Sweden, Belgium, India, Austria, Portugal, Switzerland or Luxembourg. */
  PostalCode: { input: any; output: any; }
  /** A field whose value is a CSS RGB color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGB: { input: any; output: any; }
  /** A field whose value is a CSS RGBA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGBA: { input: any; output: any; }
  /** In the US, an ABA routing transit number (`ABA RTN`) is a nine-digit code to identify the financial institution. */
  RoutingNumber: { input: any; output: any; }
  /** A field whose value conforms to the standard personal number (personnummer) formats for Sweden */
  SESSN: { input: any; output: any; }
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: { input: any; output: any; }
  /** A field whose value is a Semantic Version: https://semver.org */
  SemVer: { input: any; output: any; }
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: { input: any; output: any; }
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: { input: any; output: any; }
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: any; output: any; }
  /** A currency string, such as $21.25 */
  USCurrency: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any; }
  /** Floats that will have a value of 0 or more. */
  UnsignedFloat: { input: any; output: any; }
  /** Integers that will have a value of 0 or more. */
  UnsignedInt: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
  /** A field whose value is a UTC Offset: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
  UtcOffset: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export type Asset = {
  __typename?: 'Asset';
  /** Adaption ID */
  adaptionId: Maybe<Scalars['String']['output']>;
  /** Asset Approval State */
  approval: Maybe<AssetApprovalState>;
  /** Asset Type */
  assetTypes: Maybe<AssetTypes>;
  /** Brand ID */
  brandId: Maybe<Scalars['String']['output']>;
  /** Asset Category */
  categoryId: Maybe<Scalars['String']['output']>;
  /** Collection Ids */
  collectionId: Maybe<Array<Scalars['String']['output']>>;
  /** Content amount */
  contentAmount: Maybe<Scalars['String']['output']>;
  /** Content Factor */
  contentFactor: Maybe<Scalars['Int']['output']>;
  /** Content Unit */
  contentUnit: Maybe<Scalars['String']['output']>;
  /** Date of creation (ISO 8601 date format) */
  dateCreated: Maybe<Scalars['Date']['output']>;
  /** Date of update (ISO 8601 date format) */
  dateUpdated: Maybe<Scalars['Date']['output']>;
  /** Favorite */
  favorite: Maybe<Scalars['Boolean']['output']>;
  /** Geometry */
  geometry: Maybe<Scalars['String']['output']>;
  /** Unique ID */
  id: Maybe<Scalars['String']['output']>;
  /** Asset Image File */
  image: Maybe<Scalars['String']['output']>;
  /** Label Type */
  labelType: Maybe<LabelType>;
  /** Language Region Ids */
  languageRegionsId: Maybe<Scalars['String']['output']>;
  /** Master ID */
  masterId: Maybe<Scalars['String']['output']>;
  /** Metafields */
  metafields: Maybe<Array<MetafieldValue>>;
  /** Metashots Type */
  metashotsType: Maybe<AssetMetashotsType>;
  /** Asset display name */
  name: Maybe<Scalars['String']['output']>;
  /** Next asset ID */
  nextAssetId: Maybe<Scalars['String']['output']>;
  /** Order Index */
  oderIndex: Maybe<Scalars['Int']['output']>;
  /** Asset Parent */
  parentId: Maybe<Scalars['String']['output']>;
  /** Perspective ID */
  perspectiveId: Maybe<Scalars['String']['output']>;
  /** Previous asset ID */
  prevAssetId: Maybe<Scalars['String']['output']>;
  /** Product Type */
  productType: Maybe<ProductType>;
  /** Project ID */
  projectId: Maybe<Scalars['String']['output']>;
  /** Asset sort */
  sort: Maybe<Scalars['String']['output']>;
  /** Asset Status */
  status: Maybe<AssetStatus>;
  /** Sub Brand ID */
  subBrandId: Maybe<Scalars['String']['output']>;
  /** Subsidiary ID */
  subsidiaryId: Maybe<Scalars['String']['output']>;
  /** Asset type */
  type: Maybe<AssetType>;
  /** Type of Shot */
  typeOfShot: Maybe<TypeOfShot>;
};

export type AssetAdoptionIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export enum AssetApprovalState {
  Approved = 'Approved',
  Rejected = 'Rejected',
  Review = 'Review'
}

export type AssetApprovalStateFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCategoryIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type AssetFilter = {
  adoptionId?: InputMaybe<AssetAdoptionIdFilter>;
  approval?: InputMaybe<AssetApprovalStateFilter>;
  assetTypes?: InputMaybe<AssetTypesFilter>;
  categoryId?: InputMaybe<AssetCategoryIdFilter>;
  languageRegionId?: InputMaybe<AssetLangaugeRegionIdFilter>;
  masterId?: InputMaybe<AssetMasterIdFilter>;
  metashotsType?: InputMaybe<AssetMetashotsTypeFilter>;
  name?: InputMaybe<AssetNameFilter>;
  parentId?: InputMaybe<AssetParentIdFilter>;
  projectId?: InputMaybe<AssetProjectIdFilter>;
  status?: InputMaybe<AssetStatusFilter>;
};

export type AssetLangaugeRegionIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type AssetMasterIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export enum AssetMetashotsType {
  Adaptions = 'Adaptions',
  Beautyshot = 'Beautyshot',
  Composition = 'Composition',
  Master = 'Master',
  Perspective = 'Perspective'
}

export type AssetMetashotsTypeFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type AssetNameFilter = {
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type AssetOrder = {
  date_created?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  ordering_index?: InputMaybe<Sort>;
};

export type AssetParentIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type AssetProjectIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type AssetQuery = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<AssetFilter>;
  /** Ordering of results */
  orderBy?: InputMaybe<Array<AssetOrder>>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type AssetQueryResult = QueryResult & {
  __typename?: 'AssetQueryResult';
  items: Array<Asset>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export enum AssetStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

export type AssetStatusFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export enum AssetType {
  Image = 'Image',
  Stack = 'Stack',
  Video = 'Video'
}

export enum AssetTypes {
  /** Desgin Files */
  Illustration = 'Illustration',
  /** AW Files (Label) */
  Office = 'Office',
  Other = 'Other',
  /** Metashots (CGI) */
  Photography = 'Photography',
  Video = 'Video'
}

export type AssetTypesFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type BatchArchiveAssetsInput = {
  /** Target Assets */
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BatchCreateCollectionAssetsInput = {
  items: Array<InputMaybe<CreateCollectionAssetsInput>>;
};

export type Brand = {
  __typename?: 'Brand';
  /** Unique id */
  id: Scalars['String']['output'];
  /** Display Name of the brand */
  name: Maybe<Scalars['String']['output']>;
  /** Brand sort */
  sort: Maybe<Scalars['String']['output']>;
  /** Brand Status */
  status: Maybe<BrandStatus>;
};

export type BrandFilter = {
  name?: InputMaybe<BrandNameFilter>;
};

export type BrandNameFilter = {
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type BrandOrder = {
  name?: InputMaybe<Sort>;
};

export type BrandQuery = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<BrandFilter>;
  /** Ordering of results */
  orderBy?: InputMaybe<Array<BrandOrder>>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type BrandQueryResult = QueryResult & {
  __typename?: 'BrandQueryResult';
  items: Array<Brand>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export enum BrandStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

export type Category = {
  __typename?: 'Category';
  /** Unique id */
  id: Scalars['String']['output'];
  /** Category Display Name */
  name: Maybe<Scalars['String']['output']>;
  /** Order Index */
  orderIndex: Maybe<Scalars['Int']['output']>;
  /** Category Parent id */
  parentId: Maybe<Scalars['String']['output']>;
};

export type CategoryFilter = {
  name?: InputMaybe<CategoryNameFilter>;
  parentId?: InputMaybe<CategoryParentIdFilter>;
};

export type CategoryNameFilter = {
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryOrder = {
  id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  order_index?: InputMaybe<Sort>;
};

export type CategoryParentIdFilter = {
  /** If set only returns brands which parent has the specified id */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** If set to true only returns brands which parent is not null */
  nnull?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true only returns brands which parent is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryQuery = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<CategoryFilter>;
  /** Ordering of results */
  orderBy?: InputMaybe<Array<CategoryOrder>>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type CategoryQueryResult = QueryResult & {
  __typename?: 'CategoryQueryResult';
  items: Array<Category>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type Client = {
  __typename?: 'Client';
  /** Id */
  id: Scalars['String']['output'];
  /** Client Name */
  name: Scalars['String']['output'];
};

export type Collection = {
  __typename?: 'Collection';
  /** Auto Sync */
  autoSync: Maybe<Scalars['Boolean']['output']>;
  /** Name of user who created the collection */
  createdBy: Maybe<Scalars['String']['output']>;
  /** Date of creation (ISO 8601 date format) */
  dateCreated: Maybe<Scalars['String']['output']>;
  /** Date of update (ISO 8601 date format) */
  dateUpdated: Maybe<Scalars['String']['output']>;
  /** External Service collections */
  externalServiceConnections: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Unique id */
  id: Scalars['String']['output'];
  /** Collection Thumbnail Image */
  image: Maybe<Scalars['String']['output']>;
  /** Display name of the collection */
  name: Maybe<Scalars['String']['output']>;
  /** User IDs for which the collection is shared */
  sharedUserIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Sort of collection */
  sort: Maybe<Scalars['String']['output']>;
  /** Collection Status */
  status: Maybe<CollectionStatus>;
  /** User ID from Owner of the collection */
  userId: Maybe<Scalars['String']['output']>;
};

export type CollectionAssetsApprovalStateFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionAssetsCategoryIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionAssetsFilter = {
  approval?: InputMaybe<CollectionAssetsApprovalStateFilter>;
  assetTypes?: InputMaybe<CollectionAssetsTypesFilter>;
  categoryId?: InputMaybe<CollectionAssetsCategoryIdFilter>;
  languageRegionId?: InputMaybe<CollectionAssetsLangaugeRegionIdFilter>;
  metashotsType?: InputMaybe<CollectionAssetsMetashotsTypeFilter>;
  name?: InputMaybe<CollectionAssetsNameFilter>;
  parentId?: InputMaybe<CollectionAssetsParentIdFilter>;
  status?: InputMaybe<CollectionAssetsStatusFilter>;
};

export type CollectionAssetsLangaugeRegionIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionAssetsMetashotsTypeFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionAssetsNameFilter = {
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionAssetsOrder = {
  date_created?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  oder_index?: InputMaybe<Sort>;
};

export type CollectionAssetsParentIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionAssetsQuery = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<CollectionAssetsFilter>;
  /** Ordering of results */
  orderBy?: InputMaybe<Array<CollectionAssetsOrder>>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type CollectionAssetsQueryResult = QueryResult & {
  __typename?: 'CollectionAssetsQueryResult';
  items: Array<Asset>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type CollectionAssetsStatusFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionAssetsTypesFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionFilter = {
  name?: InputMaybe<CollectionNameFilter>;
  sharedUserIds?: InputMaybe<CollectionSharedUserIdsFilter>;
  userId?: InputMaybe<CollectionUserIdFilter>;
};

export type CollectionIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionNameFilter = {
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionOrder = {
  date_created?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

export type CollectionQuery = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<CollectionFilter>;
  /** Ordering of results */
  orderBy?: InputMaybe<Array<CollectionOrder>>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type CollectionQueryResult = QueryResult & {
  __typename?: 'CollectionQueryResult';
  items: Array<Collection>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type CollectionSharedUserIdsFilter = {
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export enum CollectionStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

/**
 * Filters on the effective time of the sync: scheduledAt when set,
 * otherwise dateCreated (legacy rows). ISO 8601 strings.
 */
export type CollectionSyncLogsDateRangeFilter = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionSyncLogsFilter = {
  dateRange?: InputMaybe<CollectionSyncLogsDateRangeFilter>;
  status?: InputMaybe<CollectionSyncLogsStatusFilter>;
  triggerType?: InputMaybe<CollectionSyncLogsTriggerTypeFilter>;
};

export type CollectionSyncLogsOrder = {
  dateCreated?: InputMaybe<Sort>;
  scheduledAt?: InputMaybe<Sort>;
};

export type CollectionSyncLogsQuery = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<CollectionSyncLogsFilter>;
  /** Ordering of results */
  orderBy?: InputMaybe<Array<CollectionSyncLogsOrder>>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type CollectionSyncLogsQueryResult = QueryResult & {
  __typename?: 'CollectionSyncLogsQueryResult';
  items: Array<MetaphoreCollectionSyncLog>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type CollectionSyncLogsStatusFilter = {
  eq?: InputMaybe<MetaphoreCollectionSyncLogStatus>;
  in?: InputMaybe<Array<MetaphoreCollectionSyncLogStatus>>;
};

export type CollectionSyncLogsTriggerTypeFilter = {
  eq?: InputMaybe<MetaphoreCollectionSyncLogTriggerType>;
};

export type CollectionUserIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type Comment = {
  __typename?: 'Comment';
  /** Related Asset Id */
  assetId: Maybe<Scalars['String']['output']>;
  /** Comment */
  comment: Scalars['String']['output'];
  /** Date of creation (ISO 8601 date format) */
  dateCreated: Maybe<Scalars['Date']['output']>;
  /** Date of update (ISO 8601 date format) */
  dateUpdated: Maybe<Scalars['Date']['output']>;
  /** Unique id */
  id: Scalars['String']['output'];
  /** Parent Id */
  parentId: Maybe<Scalars['String']['output']>;
  /** Sort of comment */
  sort: Maybe<Scalars['String']['output']>;
  /** Comment Status */
  status: Maybe<CommentStatus>;
  /** Unique id */
  userId: Scalars['String']['output'];
};

export type CommentAssetIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type CommentFilter = {
  assetId?: InputMaybe<CommentAssetIdFilter>;
};

export type CommentOrder = {
  date_created?: InputMaybe<Sort>;
  date_updated?: InputMaybe<Sort>;
};

export type CommentQuery = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<CommentFilter>;
  /** Ordering of results */
  orderBy?: InputMaybe<Array<CommentOrder>>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type CommentQueryResult = QueryResult & {
  __typename?: 'CommentQueryResult';
  items: Array<Comment>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export enum CommentStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

export type CreateAssetInput = {
  /** Adaption ID */
  adaptionId?: InputMaybe<Scalars['String']['input']>;
  /** Approved By Email */
  approvedByEmail?: InputMaybe<Scalars['String']['input']>;
  /** Asset Type */
  asset_types?: InputMaybe<AssetTypes>;
  /** Brand ID */
  brand_id?: InputMaybe<Scalars['String']['input']>;
  /** Asset Category */
  category_id?: InputMaybe<Scalars['String']['input']>;
  /** Client */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Collection IDs */
  collection_id?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Content Factor */
  contentFactor?: InputMaybe<Scalars['Int']['input']>;
  /** Content amount */
  content_amount?: InputMaybe<Scalars['String']['input']>;
  /** Content Unit */
  content_unit?: InputMaybe<Scalars['String']['input']>;
  /** Favorite */
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filename */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Geometry */
  geometry?: InputMaybe<Scalars['String']['input']>;
  /** Asset Image File */
  image: Scalars['FileUpload']['input'];
  /** Label Type ID */
  labelTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Language Region IDs */
  language_regions_id?: InputMaybe<Scalars['String']['input']>;
  /** Master ID */
  masterId?: InputMaybe<Scalars['String']['input']>;
  /** Metafield Id */
  metafields?: InputMaybe<Array<CreateMetafieldValueInput>>;
  /** Metashots Type */
  metashots_type?: InputMaybe<AssetMetashotsType>;
  /** Asset display name */
  name: Scalars['String']['input'];
  /** Next asset ID */
  next_asset_id?: InputMaybe<Scalars['String']['input']>;
  /** Order Index */
  order_index?: InputMaybe<Scalars['Int']['input']>;
  /** Asset Parent */
  parent_id?: InputMaybe<Scalars['String']['input']>;
  /** Perspective ID */
  perspectiveId?: InputMaybe<Scalars['String']['input']>;
  /** Previous asset ID */
  prev_asset_id?: InputMaybe<Scalars['String']['input']>;
  /** Product ID */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Product Type ID */
  productTypeId?: InputMaybe<Scalars['String']['input']>;
  /** Project ID */
  projectId?: InputMaybe<Scalars['String']['input']>;
  /** Status */
  status: AssetStatus;
  /** Sub Brand ID */
  sub_brand_id?: InputMaybe<Scalars['String']['input']>;
  /** Subsidiary ID */
  subsidiaryId?: InputMaybe<Scalars['String']['input']>;
  /** Asset type */
  type?: InputMaybe<AssetType>;
  /** Type of Shot ID */
  typeOfShotId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCategoryInput = {
  /** Category Display Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Order Index */
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Category Parent id */
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCollectionAssetsInput = {
  /** Asset Ids */
  assetIds: Array<InputMaybe<Scalars['String']['input']>>;
  /** Collection Id */
  collectionId: Scalars['String']['input'];
};

export type CreateCollectionInput = {
  /** Collection Display Name */
  name: Scalars['String']['input'];
};

export type CreateCommentInput = {
  /** Asset ID */
  assetId: Scalars['String']['input'];
  /** User comment */
  comment: Scalars['String']['input'];
  /** Parent */
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExternalLinkInput = {
  /** Related collection id */
  CollectionId: Scalars['String']['input'];
  /** End Date */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Start Date */
  startDate: Scalars['Date']['input'];
};

export type CreateLabelTypeInput = {
  /**
   * Clients the label type is available for
   * Only used for admin users, for non-admin users the active client is used.
   */
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
};

export type CreateMetafieldInput = {
  /** Global (if true, metafield flag will be created on all systems) */
  global: Scalars['Boolean']['input'];
  /** ID (random uuid will be generated if it's not defined) */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Display Name */
  name: Scalars['String']['input'];
  /** Options (required only of metafield types from type selections) */
  options?: InputMaybe<Array<CreateMetafieldOptionInput>>;
  /** (Optional) Indicator in which order the metafield should displayed (higher means first, default 0) */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Metafield type */
  type: MetafieldType;
  /** State of the visible of the metafield */
  visible: Scalars['Boolean']['input'];
};

export type CreateMetafieldOptionInput = {
  /** Display Name */
  name: Scalars['String']['input'];
  /** Value */
  value: Scalars['String']['input'];
};

export type CreateMetafieldValueInput = {
  /** (Optional) Boolean Value */
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Metafield ID */
  metafieldId: Scalars['String']['input'];
  /** (Optional) Option Values */
  optionValueIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** (Optional) Text Value */
  textValue?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductTypeInput = {
  /**
   * Clients the type of shot is available for
   * Only used for admin users, for non-admin users the active client is used.
   */
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
};

export type CreatePublicSharedCollectionInput = {
  /** Target Collection */
  collectionId: Scalars['String']['input'];
  /** (Optional) Mark shared collection as downloadable */
  downloadableCollection?: InputMaybe<Scalars['Boolean']['input']>;
  /** How long the link should be valid (ISO 8601 date format) */
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  /** From when the link should be valid (ISO 8601 date format) */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateSubsidiaryInput = {
  /** Unique id */
  id: Scalars['String']['input'];
  /** Language region name */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTypeOfShotInput = {
  /**
   * Clients the type of shot is available for
   * Only used for admin users, for non-admin users the active client is used.
   */
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
};

export type DeleteCollectionAssetsInput = {
  /** Asset Ids */
  assetIds: Array<InputMaybe<Scalars['String']['input']>>;
  /** Collection Id */
  collectionId: Scalars['String']['input'];
};

export type ExternalLink = {
  __typename?: 'ExternalLink';
  /** Related collection id */
  collectionId: Maybe<Scalars['String']['output']>;
  /** Moment when the external link is invalid */
  endDate: Maybe<Scalars['Date']['output']>;
  /** Unique id */
  id: Scalars['String']['output'];
  /** Moment when the external link is valid */
  startDate: Maybe<Scalars['Date']['output']>;
  /** External Link Status */
  status: Maybe<ExternalLinkStatus>;
};

export type ExternalLinkCollectionIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalLinkFilter = {
  collectionId?: InputMaybe<ExternalLinkCollectionIdFilter>;
};

export type ExternalLinkOrder = {
  collectionId?: InputMaybe<Sort>;
};

export type ExternalLinkQuery = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<ExternalLinkFilter>;
  /** Ordering of results */
  orderBy?: InputMaybe<Array<ExternalLinkOrder>>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type ExternalLinkQueryResult = QueryResult & {
  __typename?: 'ExternalLinkQueryResult';
  items: Array<ExternalLink>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export enum ExternalLinkStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

export type IamUser = {
  __typename?: 'IAMUser';
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** Firstname */
  firstname: Maybe<Scalars['String']['output']>;
  /** Unique id */
  id: Maybe<Scalars['String']['output']>;
  /** Lastname */
  lastname: Maybe<Scalars['String']['output']>;
};

export type ImportAssetInput = {
  /** Adaption ID */
  adaptionId: Scalars['String']['input'];
  /** Asset Type */
  assetTypes?: InputMaybe<AssetTypes>;
  /** Brand */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** Client Name */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Content amount */
  contentAmount?: InputMaybe<Scalars['String']['input']>;
  /** Content Factor */
  contentFactor?: InputMaybe<Scalars['Int']['input']>;
  /** Content Unit */
  contentUnit?: InputMaybe<Scalars['String']['input']>;
  /** Filename */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Geometry */
  geometry?: InputMaybe<Scalars['String']['input']>;
  /** Asset Image File */
  image: Scalars['FileUpload']['input'];
  /** Sort Flavour */
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Label Type */
  labelType?: InputMaybe<Scalars['String']['input']>;
  /** Language Region */
  languageRegion?: InputMaybe<Scalars['String']['input']>;
  /** Master ID */
  masterId: Scalars['String']['input'];
  /** Metashots Type */
  metashotsType?: InputMaybe<AssetMetashotsType>;
  /** Asset display name */
  name: Scalars['String']['input'];
  /** Package Type */
  packageType?: InputMaybe<Scalars['String']['input']>;
  /** Perspective */
  perspective?: InputMaybe<Scalars['String']['input']>;
  /** Product Type */
  productType?: InputMaybe<Scalars['String']['input']>;
  /** Project ID */
  projectId: Scalars['String']['input'];
  /** Sub Brand */
  subBrand?: InputMaybe<Scalars['String']['input']>;
  /** Subsidiary */
  subsidiary?: InputMaybe<Scalars['String']['input']>;
  /** Tag List (seperated by a coma ',') */
  tagList?: InputMaybe<Scalars['String']['input']>;
  /** Asset type */
  type?: InputMaybe<AssetType>;
  /** Type of Shot */
  typeOfShot?: InputMaybe<Scalars['String']['input']>;
};

export type LabelType = {
  __typename?: 'LabelType';
  /** ID */
  id: Scalars['String']['output'];
  /** Display Name */
  name: Scalars['String']['output'];
};

export type LabelTypeClientsFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type LabelTypeFilter = {
  clients?: InputMaybe<LabelTypeClientsFilter>;
  name?: InputMaybe<LabelTypeNameFilter>;
};

export type LabelTypeNameFilter = {
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type LabelTypeQueryInput = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<LabelTypeFilter>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type LabelTypeQueryResult = QueryResult & {
  __typename?: 'LabelTypeQueryResult';
  items: Array<LabelType>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type LanguageRegion = {
  __typename?: 'LanguageRegion';
  /** Date of creation (ISO 8601 date format) */
  dateCreated: Maybe<Scalars['Date']['output']>;
  /** Date of update (ISO 8601 date format) */
  dateUpdated: Maybe<Scalars['Date']['output']>;
  /** Unique id */
  id: Scalars['String']['output'];
  /** Language region name */
  name: Maybe<Scalars['String']['output']>;
  /** Sort of language region */
  sort: Maybe<Scalars['String']['output']>;
  /** Language Region Status */
  status: Maybe<LanguageRegionStatus>;
};

export type LanguageRegionFilter = {
  languageRegionId?: InputMaybe<LanguageRegionIdFilter>;
  status?: InputMaybe<LanguageRegionStatusFilter>;
};

export type LanguageRegionIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type LanguageRegionOrder = {
  date_created?: InputMaybe<Sort>;
  date_updated?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

export type LanguageRegionQuery = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<LanguageRegionFilter>;
  /** Ordering of results */
  orderBy?: InputMaybe<Array<LanguageRegionOrder>>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type LanguageRegionQueryResult = QueryResult & {
  __typename?: 'LanguageRegionQueryResult';
  items: Array<LanguageRegion>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export enum LanguageRegionStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

export type LanguageRegionStatusFilter = {
  eq?: InputMaybe<LanguageRegionStatus>;
};

export type Metafield = {
  __typename?: 'Metafield';
  /** Global Metafield */
  global: Scalars['Boolean']['output'];
  /** Unique id */
  id: Scalars['String']['output'];
  /** Display Name */
  name: Scalars['String']['output'];
  /** Options */
  options: Maybe<Array<MetafieldOption>>;
  /** Indicator in which order the metafield should displayed (higher means first) */
  order: Scalars['Int']['output'];
  /** Status */
  status: MetafieldStatus;
  /** Metafield type */
  type: MetafieldType;
  /** State of the visible of the metafield */
  visible: Scalars['Boolean']['output'];
};

export type MetafieldFilter = {
  name?: InputMaybe<MetafieldNameFilter>;
  visible?: InputMaybe<MetafieldVisibleFilter>;
};

export type MetafieldNameFilter = {
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type MetafieldOption = {
  __typename?: 'MetafieldOption';
  /** Display Name */
  name: Scalars['String']['output'];
  /** Value */
  value: Scalars['String']['output'];
};

export type MetafieldOrder = {
  id?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
  order?: InputMaybe<Sort>;
};

export type MetafieldQueryInput = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<MetafieldFilter>;
  /** Ordering of results */
  orderBy?: InputMaybe<Array<MetafieldOrder>>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type MetafieldQueryResult = QueryResult & {
  __typename?: 'MetafieldQueryResult';
  items: Array<Metafield>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

/** Describe the current Metafield Status */
export enum MetafieldStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Published = 'Published'
}

/** Define which type the Metafield is from */
export enum MetafieldType {
  Boolean = 'Boolean',
  MultiSelection = 'MultiSelection',
  Selection = 'Selection',
  Text = 'Text'
}

export type MetafieldValue = {
  __typename?: 'MetafieldValue';
  /** (Optional) Boolean Value */
  booleanValue: Maybe<Scalars['Boolean']['output']>;
  /** Unique ID */
  id: Scalars['String']['output'];
  /** Metafield */
  metafield: Metafield;
  /** (Optional) Option Values */
  optionsValue: Maybe<Array<MetafieldOption>>;
  /** (Optional) Text Value */
  textValue: Maybe<Scalars['String']['output']>;
};

export type MetafieldValueAssetIdFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type MetafieldValueFilters = {
  assetId?: InputMaybe<MetafieldValueAssetIdFilter>;
};

export type MetafieldValueQueryInput = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<MetafieldValueFilters>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type MetafieldValueQueryResult = QueryResult & {
  __typename?: 'MetafieldValueQueryResult';
  items: Array<MetafieldValue>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type MetafieldVisibleFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type MetaphoreAssetSyncLog = {
  __typename?: 'MetaphoreAssetSyncLog';
  /** Asset */
  asset: Maybe<Scalars['String']['output']>;
  /** Collection ID */
  collectionId: Maybe<Scalars['String']['output']>;
  /** Date of creation (ISO 8601 date format) */
  dateCreated: Maybe<Scalars['String']['output']>;
  /** Unique ID */
  id: Scalars['String']['output'];
  /** Platform */
  platform: Maybe<Scalars['String']['output']>;
  /** Server Response */
  server_response: Maybe<Scalars['String']['output']>;
  /** Status */
  status: Maybe<MetaphoreAssetSyncLogStatus>;
};

export enum MetaphoreAssetSyncLogStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Successful = 'Successful'
}

export type MetaphoreCollectionSyncLog = {
  __typename?: 'MetaphoreCollectionSyncLog';
  /** Asset Ids */
  assetIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Assets included in this sync with attribution */
  assets: Maybe<Array<MetaphoreCollectionSyncLogAsset>>;
  /** User id of the admin who canceled the sync */
  canceledBy: Maybe<Scalars['String']['output']>;
  /** Display name of who canceled the sync */
  canceledByName: Maybe<Scalars['String']['output']>;
  /** Date of creation (ISO 8601 date format) */
  dateCreated: Maybe<Scalars['String']['output']>;
  /** Date of last update (ISO 8601 date format) */
  dateUpdated: Maybe<Scalars['String']['output']>;
  /** Why the sync failed (only visible for admins) */
  errorLog: Maybe<Scalars['String']['output']>;
  /** Time the sync execution started (ISO 8601 date format) */
  executedAt: Maybe<Scalars['String']['output']>;
  /** Unique ID */
  id: Scalars['String']['output'];
  /** Time the sync is due to run (ISO 8601 date format) */
  scheduledAt: Maybe<Scalars['String']['output']>;
  /** User id of the admin who started the sync via "run now" */
  startedBy: Maybe<Scalars['String']['output']>;
  /** Status */
  status: Maybe<MetaphoreCollectionSyncLogStatus>;
  /** What created the sync */
  triggerType: Maybe<MetaphoreCollectionSyncLogTriggerType>;
  /** User id of the user who triggered the sync */
  triggeredBy: Maybe<Scalars['String']['output']>;
  /** Display name of the user who triggered the sync */
  triggeredByName: Maybe<Scalars['String']['output']>;
};

export type MetaphoreCollectionSyncLogAsset = {
  __typename?: 'MetaphoreCollectionSyncLogAsset';
  /** Date the asset joined the sync (ISO 8601 date format) */
  addedAt: Maybe<Scalars['String']['output']>;
  /** User id of the user whose asset-add put this asset into the sync */
  addedBy: Maybe<Scalars['String']['output']>;
  /** Display name of the user whose asset-add put this asset into the sync */
  addedByName: Maybe<Scalars['String']['output']>;
  /** Asset ID */
  id: Scalars['String']['output'];
  /** Image file id of the asset */
  image: Maybe<Scalars['String']['output']>;
  /** Asset name */
  name: Maybe<Scalars['String']['output']>;
};

export type MetaphoreCollectionSyncLogResult = {
  __typename?: 'MetaphoreCollectionSyncLogResult';
  item: Maybe<MetaphoreCollectionSyncLog>;
};

export enum MetaphoreCollectionSyncLogStatus {
  Canceled = 'Canceled',
  Failed = 'Failed',
  Pending = 'Pending',
  Scheduled = 'Scheduled',
  Skipped = 'Skipped',
  Successful = 'Successful'
}

export enum MetaphoreCollectionSyncLogTriggerType {
  Auto = 'Auto',
  Manual = 'Manual'
}

export type Mutation = {
  __typename?: 'Mutation';
  archiveMetafield: Scalars['Boolean']['output'];
  batchArchiveAssets: Scalars['Boolean']['output'];
  batchCreateCollectionAssets: Scalars['Boolean']['output'];
  /** Cancel an upcoming (Scheduled) sync. Admin only. */
  cancelScheduledCollectionSync: MetaphoreCollectionSyncLog;
  createAsset: Asset;
  createCategory: Category;
  createCollection: Collection;
  createCollectionAssets: Scalars['Boolean']['output'];
  createComment: Comment;
  createExternalLink: ExternalLink;
  createLabelType: LabelType;
  createMetafield: Metafield;
  createMetafieldValue: MetafieldValue;
  createProductType: ProductType;
  createPublicSharedCollection: PublicSharedCollectionAccessToken;
  createSubsidiary: Subsidiary;
  createTypeOfShot: TypeOfShot;
  deleteAsset: Scalars['Boolean']['output'];
  deleteCategory: Scalars['Boolean']['output'];
  deleteCollection: Scalars['Boolean']['output'];
  deleteCollectionAssets: Scalars['Boolean']['output'];
  deleteComment: Scalars['Boolean']['output'];
  deleteExternalLink: Scalars['Boolean']['output'];
  deleteMetafieldValue: Scalars['Boolean']['output'];
  deletePublicSharedCollection: Maybe<Scalars['Boolean']['output']>;
  importAsset: Asset;
  /** Execute an upcoming (Scheduled) sync immediately. Admin only. */
  runScheduledCollectionSyncNow: MetaphoreCollectionSyncLog;
  shareCollection: Scalars['Boolean']['output'];
  syncCollectionAssets: Scalars['Boolean']['output'];
  updateAsset: Asset;
  updateCategory: Category;
  updateCollection: Collection;
  updateCollectionThumbnail: Scalars['Boolean']['output'];
  updateComment: Comment;
  updateMetafield: Metafield;
  updateMetafieldValue: MetafieldValue;
  updatePublicSharedCollection: PublicSharedCollectionAccessToken;
};


export type MutationArchiveMetafieldArgs = {
  id: Scalars['String']['input'];
};


export type MutationBatchArchiveAssetsArgs = {
  input: BatchArchiveAssetsInput;
};


export type MutationBatchCreateCollectionAssetsArgs = {
  input: BatchCreateCollectionAssetsInput;
};


export type MutationCancelScheduledCollectionSyncArgs = {
  id: Scalars['String']['input'];
};


export type MutationCreateAssetArgs = {
  input: CreateAssetInput;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateCollectionArgs = {
  input: CreateCollectionInput;
};


export type MutationCreateCollectionAssetsArgs = {
  input: CreateCollectionAssetsInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateExternalLinkArgs = {
  input: CreateExternalLinkInput;
};


export type MutationCreateLabelTypeArgs = {
  input: CreateLabelTypeInput;
};


export type MutationCreateMetafieldArgs = {
  input: CreateMetafieldInput;
};


export type MutationCreateMetafieldValueArgs = {
  input: CreateMetafieldValueInput;
};


export type MutationCreateProductTypeArgs = {
  input: CreateProductTypeInput;
};


export type MutationCreatePublicSharedCollectionArgs = {
  input: CreatePublicSharedCollectionInput;
};


export type MutationCreateSubsidiaryArgs = {
  input: CreateSubsidiaryInput;
};


export type MutationCreateTypeOfShotArgs = {
  input: CreateTypeOfShotInput;
};


export type MutationDeleteAssetArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCollectionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCollectionAssetsArgs = {
  input: DeleteCollectionAssetsInput;
};


export type MutationDeleteCommentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteExternalLinkArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMetafieldValueArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePublicSharedCollectionArgs = {
  id: Scalars['String']['input'];
};


export type MutationImportAssetArgs = {
  input: ImportAssetInput;
};


export type MutationRunScheduledCollectionSyncNowArgs = {
  id: Scalars['String']['input'];
};


export type MutationShareCollectionArgs = {
  input: ShareCollectionInput;
};


export type MutationSyncCollectionAssetsArgs = {
  input: SyncCollectionAssetsInput;
};


export type MutationUpdateAssetArgs = {
  id: Scalars['String']['input'];
  input: UpdateAssetInput;
};


export type MutationUpdateCategoryArgs = {
  id: Scalars['String']['input'];
  input: UpdateCategoryInput;
};


export type MutationUpdateCollectionArgs = {
  id: Scalars['String']['input'];
  input: UpdateCollectionInput;
};


export type MutationUpdateCollectionThumbnailArgs = {
  input: UpdateCollectionThumbnailInput;
};


export type MutationUpdateCommentArgs = {
  id: Scalars['String']['input'];
  input: UpdateCommentInput;
};


export type MutationUpdateMetafieldArgs = {
  id: Scalars['String']['input'];
  input: UpdateMetafieldInput;
};


export type MutationUpdateMetafieldValueArgs = {
  id: Scalars['String']['input'];
  input: UpdateMetafieldValueInput;
};


export type MutationUpdatePublicSharedCollectionArgs = {
  input: UpdatePublicSharedCollectionAccessTokenInput;
};

export type Pagination = {
  /**
   * Set the maximum number of items that will be returned
   * @default 100
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Skip the first n items in the response
   * @default 0
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * An alternative to offset.
   * Page is a way to set offset under the hood by calculating `limit * page`.
   * Page is 1-indexed.
   * If set it will be used over `offset`
   */
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductType = {
  __typename?: 'ProductType';
  /** ID */
  id: Scalars['String']['output'];
  /** Display Name */
  name: Scalars['String']['output'];
};

export type ProductTypeClientsFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type ProductTypeFilters = {
  clients?: InputMaybe<ProductTypeClientsFilter>;
  name?: InputMaybe<ProductTypeNameFilter>;
};

export type ProductTypeNameFilter = {
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type ProductTypeQueryInput = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<ProductTypeFilters>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type ProductTypeQueryResult = QueryResult & {
  __typename?: 'ProductTypeQueryResult';
  items: Array<ProductType>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type PublicSharedCollectionAccessToken = {
  __typename?: 'PublicSharedCollectionAccessToken';
  /** Collection */
  collection: Maybe<Collection>;
  /** Collection ID */
  collectionId: Maybe<Scalars['String']['output']>;
  /** Created by */
  createdBy: Maybe<Scalars['String']['output']>;
  /** Downloadable Collection */
  downloadableCollection: Scalars['Boolean']['output'];
  /** Date when the token expiated (ISO 8601 date format) */
  expirationDate: Maybe<Scalars['Date']['output']>;
  /** ID (refer also to the access token) */
  id: Scalars['String']['output'];
  /** Date when the token are available (ISO 8601 date format) */
  startDate: Maybe<Scalars['Date']['output']>;
  /** Suspended indicated if its temporary disabled */
  suspended: Scalars['Boolean']['output'];
};

export type PublicSharedCollectionFilter = {
  collectionId?: InputMaybe<CollectionIdFilter>;
};

export type PublicSharedCollectionOrder = {
  expiration_date?: InputMaybe<Sort>;
  start_date?: InputMaybe<Sort>;
};

export type PublicSharedCollectionQuery = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<PublicSharedCollectionFilter>;
  /** Ordering of results */
  orderBy?: InputMaybe<Array<PublicSharedCollectionOrder>>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type PublicSharedCollectionQueryResult = QueryResult & {
  __typename?: 'PublicSharedCollectionQueryResult';
  items: Array<PublicSharedCollectionAccessToken>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  asset: Asset;
  assets: AssetQueryResult;
  brand: Brand;
  brands: BrandQueryResult;
  categories: CategoryQueryResult;
  category: Category;
  client: Client;
  collection: Collection;
  collectionAssets: CollectionAssetsQueryResult;
  /**
   * Per-asset sync logs of one collection sync — the detailed error log.
   * Admin only.
   */
  collectionSyncLogAssetLogs: Array<MetaphoreAssetSyncLog>;
  /**
   * Previous and upcoming syncs of a collection.
   * Admins see all syncs; other users only see the syncs they triggered or
   * contributed assets to.
   */
  collectionSyncLogs: CollectionSyncLogsQueryResult;
  collections: CollectionQueryResult;
  comment: Comment;
  comments: CommentQueryResult;
  externalLink: ExternalLink;
  externalLinks: ExternalLinkQueryResult;
  getLatestCollectionSyncLog: Maybe<MetaphoreCollectionSyncLogResult>;
  labelType: LabelType;
  labelTypes: LabelTypeQueryResult;
  languageRegion: LanguageRegion;
  languageRegions: LanguageRegionQueryResult;
  /** Info about the logged in user */
  me: Maybe<User>;
  metafield: Metafield;
  metafieldValue: MetafieldValue;
  metafieldValues: MetafieldValueQueryResult;
  metafields: MetafieldQueryResult;
  productType: ProductType;
  productTypes: ProductTypeQueryResult;
  publicSharedCollectionAccessToken: PublicSharedCollectionAccessToken;
  publicSharedCollectionAccessTokens: PublicSharedCollectionQueryResult;
  sharedCollections: SharedCollectionQueryResult;
  subsidiaries: Maybe<Array<Maybe<Subsidiary>>>;
  typeOfShot: TypeOfShot;
  typeOfShots: TypeOfShotQueryResult;
  /** @deprecated instead use the users query endpoint */
  userPoolUsers: UserPoolQueryResult;
  users: UserQueryResult;
};


export type QueryAssetArgs = {
  id: Scalars['String']['input'];
};


export type QueryAssetsArgs = {
  query?: InputMaybe<AssetQuery>;
};


export type QueryBrandArgs = {
  id: Scalars['String']['input'];
};


export type QueryBrandsArgs = {
  query?: InputMaybe<BrandQuery>;
};


export type QueryCategoriesArgs = {
  query?: InputMaybe<CategoryQuery>;
};


export type QueryCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryClientArgs = {
  id: Scalars['String']['input'];
};


export type QueryCollectionArgs = {
  id: Scalars['String']['input'];
};


export type QueryCollectionAssetsArgs = {
  collectionId: Scalars['String']['input'];
  query?: InputMaybe<CollectionAssetsQuery>;
};


export type QueryCollectionSyncLogAssetLogsArgs = {
  collectionSyncLogId: Scalars['String']['input'];
};


export type QueryCollectionSyncLogsArgs = {
  collectionId: Scalars['String']['input'];
  query?: InputMaybe<CollectionSyncLogsQuery>;
};


export type QueryCollectionsArgs = {
  query?: InputMaybe<CollectionQuery>;
};


export type QueryCommentArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommentsArgs = {
  query?: InputMaybe<CommentQuery>;
};


export type QueryExternalLinkArgs = {
  id: Scalars['String']['input'];
};


export type QueryExternalLinksArgs = {
  query?: InputMaybe<ExternalLinkQuery>;
};


export type QueryGetLatestCollectionSyncLogArgs = {
  id: Scalars['String']['input'];
};


export type QueryLabelTypeArgs = {
  id: Scalars['String']['input'];
};


export type QueryLabelTypesArgs = {
  query?: InputMaybe<LabelTypeQueryInput>;
};


export type QueryLanguageRegionArgs = {
  id: Scalars['String']['input'];
};


export type QueryLanguageRegionsArgs = {
  query?: InputMaybe<LanguageRegionQuery>;
};


export type QueryMetafieldArgs = {
  id: Scalars['String']['input'];
};


export type QueryMetafieldValueArgs = {
  id: Scalars['String']['input'];
};


export type QueryMetafieldValuesArgs = {
  query?: InputMaybe<MetafieldValueQueryInput>;
};


export type QueryMetafieldsArgs = {
  query?: InputMaybe<MetafieldQueryInput>;
};


export type QueryProductTypeArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductTypesArgs = {
  query?: InputMaybe<ProductTypeQueryInput>;
};


export type QueryPublicSharedCollectionAccessTokenArgs = {
  id: Scalars['String']['input'];
};


export type QueryPublicSharedCollectionAccessTokensArgs = {
  query?: InputMaybe<PublicSharedCollectionQuery>;
};


export type QuerySharedCollectionsArgs = {
  query?: InputMaybe<SharedCollectionQuery>;
  userId: Scalars['String']['input'];
};


export type QueryTypeOfShotArgs = {
  id: Scalars['String']['input'];
};


export type QueryTypeOfShotsArgs = {
  query?: InputMaybe<TypeOfShotQueryInput>;
};


export type QueryUserPoolUsersArgs = {
  query?: InputMaybe<UserPoolQuery>;
};


export type QueryUsersArgs = {
  input?: InputMaybe<UserQueryInput>;
};

export type QueryResult = {
  /**
   * Maximum number of items to return
   * Used for pagination.
   */
  limit: Maybe<Scalars['Int']['output']>;
  /**
   * Number of items to skip from result before returning.
   * Used for pagination.
   */
  offset: Maybe<Scalars['Int']['output']>;
  /**
   * An alternative to offset.
   * Page is a way to set offset under the hood by calculating `limit * page`.
   * Page is 1-indexed.
   * If set it will be used over `offset`
   */
  page: Maybe<Scalars['Int']['output']>;
  /** Total number of items that matched the query */
  totalCount: Scalars['Int']['output'];
};

export type ShareCollectionInput = {
  /** Target Collection ID */
  collectionId: Scalars['String']['input'];
  /** User IDs */
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SharedCollectionFilter = {
  name?: InputMaybe<SharedCollectionNameFilter>;
  sharedUserIds?: InputMaybe<SharedCollectionSharedUserIdsFilter>;
};

export type SharedCollectionNameFilter = {
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type SharedCollectionOrder = {
  date_created?: InputMaybe<Sort>;
  name?: InputMaybe<Sort>;
};

export type SharedCollectionQuery = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<SharedCollectionFilter>;
  /** Ordering of results */
  orderBy?: InputMaybe<Array<SharedCollectionOrder>>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
  /** User ID */
  userId: Scalars['String']['input'];
};

export type SharedCollectionQueryResult = QueryResult & {
  __typename?: 'SharedCollectionQueryResult';
  items: Array<Collection>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type SharedCollectionSharedUserIdsFilter = {
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export enum Sort {
  Asc = 'Asc',
  Desc = 'Desc'
}

export type Subsidiary = {
  __typename?: 'Subsidiary';
  /** Date of creation (ISO 8601 date format) */
  dateCreated: Maybe<Scalars['Date']['output']>;
  /** Unique id */
  id: Scalars['String']['output'];
  /** Language region name */
  name: Maybe<Scalars['String']['output']>;
  /** Status */
  status: Maybe<Scalars['String']['output']>;
};

export type SyncCollectionAssetsInput = {
  /** Band ID */
  brandId?: InputMaybe<Scalars['String']['input']>;
  /** Collection ID */
  collectionId: Scalars['String']['input'];
  /** Platform IDs */
  platformIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Subsidiary ID */
  subsidiaryId?: InputMaybe<Scalars['String']['input']>;
};

export type TypeOfShot = {
  __typename?: 'TypeOfShot';
  /** ID */
  id: Scalars['String']['output'];
  /** Display Name */
  name: Scalars['String']['output'];
};

export type TypeOfShotClientsFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type TypeOfShotFilter = {
  clients?: InputMaybe<TypeOfShotClientsFilter>;
  name?: InputMaybe<TypeOfShotNameFilter>;
};

export type TypeOfShotNameFilter = {
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type TypeOfShotQueryInput = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<TypeOfShotFilter>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type TypeOfShotQueryResult = QueryResult & {
  __typename?: 'TypeOfShotQueryResult';
  items: Array<TypeOfShot>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type UpdateAssetInput = {
  /** Adaption Id */
  adaption_id?: InputMaybe<Scalars['String']['input']>;
  /** Asset Approval State */
  approval?: InputMaybe<AssetApprovalState>;
  /** Asset Type */
  asset_types?: InputMaybe<AssetTypes>;
  /** Brand id */
  brand_id?: InputMaybe<Scalars['String']['input']>;
  /** Asset Category */
  category_id?: InputMaybe<Scalars['String']['input']>;
  /** Collection Ids */
  collection_id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Content Factor */
  contentFactor?: InputMaybe<Scalars['Int']['input']>;
  /** Content amount */
  content_amount?: InputMaybe<Scalars['String']['input']>;
  /** Content Unit */
  content_unit?: InputMaybe<Scalars['String']['input']>;
  /** Favorite */
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Geometry */
  geometry?: InputMaybe<Scalars['String']['input']>;
  /** Asset Image File */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Label Type Id */
  label_type_id?: InputMaybe<Scalars['String']['input']>;
  /** Language Region Ids */
  language_regions_id?: InputMaybe<Scalars['String']['input']>;
  /** Master Id */
  master_id?: InputMaybe<Scalars['String']['input']>;
  /** Metashots Type */
  metashots_type?: InputMaybe<AssetMetashotsType>;
  /** Asset display name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Next asset id */
  next_asset_id?: InputMaybe<Scalars['String']['input']>;
  /** Order Index */
  order_index?: InputMaybe<Scalars['Int']['input']>;
  /** Asset Parent */
  parent_id?: InputMaybe<Scalars['String']['input']>;
  /** Perspective ID */
  perspective_id?: InputMaybe<Scalars['String']['input']>;
  /** Previous asset id */
  prev_asset_id?: InputMaybe<Scalars['String']['input']>;
  /** Product Type Id */
  product_type_id?: InputMaybe<Scalars['String']['input']>;
  /** Project Id */
  project_id?: InputMaybe<Scalars['String']['input']>;
  /** Sub Brand id */
  sub_brand_id?: InputMaybe<Scalars['String']['input']>;
  /** Asset type */
  type?: InputMaybe<AssetType>;
  /** Type of Shot Id */
  type_of_shot_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCategoryInput = {
  /** Category Display Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Order Index */
  orderIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Category Parent id */
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCollectionInput = {
  /** Collection Display Name */
  name: Scalars['String']['input'];
};

export type UpdateCollectionThumbnailInput = {
  /** Target asset as thumbnail */
  assetId: Scalars['String']['input'];
  /** Collection ID */
  collectionId: Scalars['String']['input'];
};

export type UpdateCommentInput = {
  /** User comment */
  comment: Scalars['String']['input'];
};

export type UpdateMetafieldInput = {
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Sort Order */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Visible */
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMetafieldValueInput = {
  /** (Optional) Boolean Value */
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** (Optional) Option Values */
  optionValueIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** (Optional) Text Value */
  textValue?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePublicSharedCollectionAccessTokenInput = {
  /** (Optional) Mark shared collection as downloadable */
  downloadableCollection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date when the token expiated (ISO 8601 date format) */
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  /** ID */
  id: Scalars['String']['input'];
  /** Date when the token are available (ISO 8601 date format) */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Suspended */
  suspended?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User = {
  __typename?: 'User';
  /** Id of active client */
  activeClientId: Maybe<Scalars['String']['output']>;
  /** Ids of clients the user belongs to */
  clientIds: Maybe<Array<Scalars['String']['output']>>;
  /** Clients Info */
  clients: Maybe<Array<Client>>;
  /** Mail address of user */
  email: Maybe<Scalars['String']['output']>;
  /** Groups the user belongs t */
  groups: Maybe<Array<Scalars['String']['output']>>;
  /** Unique id */
  id: Scalars['String']['output'];
  /** Indicates if user is an administrator */
  isAdmin: Maybe<Scalars['Boolean']['output']>;
  /** Human readable name */
  name: Maybe<Scalars['String']['output']>;
  /** Permissions of the user */
  permissions: Maybe<Array<Scalars['String']['output']>>;
  /** Unique username */
  username: Maybe<Scalars['String']['output']>;
};

export type UserFilter = {
  /** Filter by email address (prefix match by default, exact match if exact is true) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Filter by email verification status */
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by account status */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When true, field-level filters (email, username, firstName, lastName) must
   * match exactly rather than as a prefix/substring.
   * Has no effect when the name (search) filter is used.
   */
  exact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by first name (prefix match by default, exact match if exact is true) */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by last name (prefix match by default, exact match if exact is true) */
  lastName?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<UserSearchFilter>;
  /** Filter by username (prefix match by default, exact match if exact is true) */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserPoolFilter = {
  userPoolIds?: InputMaybe<UserPoolIdsFilter>;
};

export type UserPoolIdsFilter = {
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserPoolOrder = {
  id?: InputMaybe<Sort>;
  keycloak_user_id?: InputMaybe<Sort>;
};

export type UserPoolQuery = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<UserPoolFilter>;
  /** Ordering of results */
  orderBy?: InputMaybe<Array<UserPoolOrder>>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type UserPoolQueryResult = QueryResult & {
  __typename?: 'UserPoolQueryResult';
  items: Array<UserPoolUser>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type UserPoolUser = {
  __typename?: 'UserPoolUser';
  /** Unique id */
  id: Scalars['String']['output'];
};

export type UserQueryInput = {
  /** Filter that returned items have to fulfill */
  filter?: InputMaybe<UserFilter>;
  /**
   * Pagination settings
   * @default First 100 items
   */
  pagination?: InputMaybe<Pagination>;
};

export type UserQueryResult = QueryResult & {
  __typename?: 'UserQueryResult';
  items: Array<IamUser>;
  limit: Maybe<Scalars['Int']['output']>;
  offset: Maybe<Scalars['Int']['output']>;
  page: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type UserSearchFilter = {
  /**
   * Case-insensitive substring/prefix match against username, first name,
   * last name, and email. Maps to Keycloak's cross-field `search` param.
   * When set, field-level filters (email, username, firstName, lastName)
   * are ignored by Keycloak.
   */
  icontains?: InputMaybe<Scalars['String']['input']>;
};

export type BrandsQueryVariables = Exact<{
  query?: InputMaybe<BrandQuery>;
}>;


export type BrandsQuery = { __typename?: 'Query', brands: { __typename?: 'BrandQueryResult', items: Array<{ __typename?: 'Brand', name: string | null, id: string }> } };

export type SubsidiariesQueryVariables = Exact<{ [key: string]: never; }>;


export type SubsidiariesQuery = { __typename?: 'Query', subsidiaries: Array<{ __typename?: 'Subsidiary', name: string | null, id: string } | null> | null };

export type SyncCollectionAssetsMutationVariables = Exact<{
  input: SyncCollectionAssetsInput;
}>;


export type SyncCollectionAssetsMutation = { __typename?: 'Mutation', syncCollectionAssets: boolean };

export type UpdateAssetMutationVariables = Exact<{
  updateAssetId: Scalars['String']['input'];
  input: UpdateAssetInput;
}>;


export type UpdateAssetMutation = { __typename?: 'Mutation', updateAsset: { __typename?: 'Asset', id: string | null, approval: AssetApprovalState | null, status: AssetStatus | null, sort: string | null, type: AssetType | null, name: string | null, image: string | null, parentId: string | null, categoryId: string | null, nextAssetId: string | null, prevAssetId: string | null, contentAmount: string | null, contentUnit: string | null, favorite: boolean | null, geometry: string | null, metashotsType: AssetMetashotsType | null, languageRegionsId: string | null, assetTypes: AssetTypes | null, brandId: string | null, collectionId: Array<string> | null, oderIndex: number | null, dateCreated: string | null, dateUpdated: string | null, projectId: string | null, masterId: string | null, adaptionId: string | null } };

export type BatchArchiveAssetsMutationVariables = Exact<{
  input: BatchArchiveAssetsInput;
}>;


export type BatchArchiveAssetsMutation = { __typename?: 'Mutation', batchArchiveAssets: boolean };

export type DeleteAssetMutationVariables = Exact<{
  deleteAssetId: Scalars['String']['input'];
}>;


export type DeleteAssetMutation = { __typename?: 'Mutation', deleteAsset: boolean };

export type DeleteCollectionAssetsMutationVariables = Exact<{
  input: DeleteCollectionAssetsInput;
}>;


export type DeleteCollectionAssetsMutation = { __typename?: 'Mutation', deleteCollectionAssets: boolean };

export type CreateCategoryMutationVariables = Exact<{
  input: CreateCategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory: { __typename?: 'Category', id: string, name: string | null, parentId: string | null, orderIndex: number | null } };

export type UpdateCategoryMutationVariables = Exact<{
  updateCategoryId: Scalars['String']['input'];
  input: UpdateCategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'Category', id: string, name: string | null, parentId: string | null, orderIndex: number | null } };

export type CreateCollectionAssetsMutationVariables = Exact<{
  input: CreateCollectionAssetsInput;
}>;


export type CreateCollectionAssetsMutation = { __typename?: 'Mutation', createCollectionAssets: boolean };

export type BatchCreateCollectionAssetsMutationVariables = Exact<{
  input: BatchCreateCollectionAssetsInput;
}>;


export type BatchCreateCollectionAssetsMutation = { __typename?: 'Mutation', batchCreateCollectionAssets: boolean };

export type DeleteCollectionMutationVariables = Exact<{
  deleteCollectionId: Scalars['String']['input'];
}>;


export type DeleteCollectionMutation = { __typename?: 'Mutation', deleteCollection: boolean };

export type UpdateCollectionMutationVariables = Exact<{
  updateCollectionId: Scalars['String']['input'];
  input: UpdateCollectionInput;
}>;


export type UpdateCollectionMutation = { __typename?: 'Mutation', updateCollection: { __typename?: 'Collection', id: string, status: CollectionStatus | null, sort: string | null, name: string | null, image: string | null, userId: string | null, sharedUserIds: Array<string | null> | null, dateCreated: string | null, dateUpdated: string | null, createdBy: string | null } };

export type UpdateCollectionThumbnailMutationVariables = Exact<{
  input: UpdateCollectionThumbnailInput;
}>;


export type UpdateCollectionThumbnailMutation = { __typename?: 'Mutation', updateCollectionThumbnail: boolean };

export type CreateCollectionMutationVariables = Exact<{
  input: CreateCollectionInput;
}>;


export type CreateCollectionMutation = { __typename?: 'Mutation', createCollection: { __typename?: 'Collection', id: string, status: CollectionStatus | null, sort: string | null, name: string | null, image: string | null, userId: string | null, sharedUserIds: Array<string | null> | null, dateCreated: string | null, dateUpdated: string | null, createdBy: string | null } };

export type ShareCollectionMutationVariables = Exact<{
  input: ShareCollectionInput;
}>;


export type ShareCollectionMutation = { __typename?: 'Mutation', shareCollection: boolean };

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'Comment', id: string, status: CommentStatus | null, sort: string | null, assetId: string | null, parentId: string | null, comment: string, dateCreated: string | null, dateUpdated: string | null } };

export type DeleteCommentMutationVariables = Exact<{
  deleteCommentId: Scalars['String']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: boolean };

export type UpdateCommentMutationVariables = Exact<{
  updateCommentId: Scalars['String']['input'];
  input: UpdateCommentInput;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'Comment', id: string, status: CommentStatus | null, sort: string | null, assetId: string | null, parentId: string | null, comment: string, dateCreated: string | null, dateUpdated: string | null } };

export type CreatePublicSharedCollectionMutationVariables = Exact<{
  input: CreatePublicSharedCollectionInput;
}>;


export type CreatePublicSharedCollectionMutation = { __typename?: 'Mutation', createPublicSharedCollection: { __typename?: 'PublicSharedCollectionAccessToken', suspended: boolean, startDate: string | null, id: string, expirationDate: string | null, createdBy: string | null, collectionId: string | null } };

export type DeletePublicSharedCollectionMutationVariables = Exact<{
  deletePublicSharedCollectionId: Scalars['String']['input'];
}>;


export type DeletePublicSharedCollectionMutation = { __typename?: 'Mutation', deletePublicSharedCollection: boolean | null };

export type CancelScheduledCollectionSyncMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CancelScheduledCollectionSyncMutation = { __typename?: 'Mutation', cancelScheduledCollectionSync: { __typename?: 'MetaphoreCollectionSyncLog', id: string, status: MetaphoreCollectionSyncLogStatus | null, canceledBy: string | null, canceledByName: string | null } };

export type RunScheduledCollectionSyncNowMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RunScheduledCollectionSyncNowMutation = { __typename?: 'Mutation', runScheduledCollectionSyncNow: { __typename?: 'MetaphoreCollectionSyncLog', id: string, status: MetaphoreCollectionSyncLogStatus | null, executedAt: string | null, startedBy: string | null } };

export type MutationMutationVariables = Exact<{
  input: CreateAssetInput;
}>;


export type MutationMutation = { __typename?: 'Mutation', createAsset: { __typename?: 'Asset', id: string | null } };

export type GetAssetQueryVariables = Exact<{
  assetId: Scalars['String']['input'];
}>;


export type GetAssetQuery = { __typename?: 'Query', asset: { __typename?: 'Asset', id: string | null, approval: AssetApprovalState | null, status: AssetStatus | null, sort: string | null, type: AssetType | null, name: string | null, image: string | null, parentId: string | null, categoryId: string | null, nextAssetId: string | null, prevAssetId: string | null, contentAmount: string | null, contentUnit: string | null, favorite: boolean | null, geometry: string | null, metashotsType: AssetMetashotsType | null, assetTypes: AssetTypes | null, brandId: string | null, collectionId: Array<string> | null, oderIndex: number | null, dateCreated: string | null, dateUpdated: string | null, adaptionId: string | null, projectId: string | null, masterId: string | null, productType: { __typename?: 'ProductType', id: string, name: string } | null, labelType: { __typename?: 'LabelType', id: string, name: string } | null, typeOfShot: { __typename?: 'TypeOfShot', id: string, name: string } | null } };

export type GetAssetsQueryVariables = Exact<{
  query?: InputMaybe<AssetQuery>;
}>;


export type GetAssetsQuery = { __typename?: 'Query', assets: { __typename?: 'AssetQueryResult', totalCount: number, page: number | null, offset: number | null, items: Array<{ __typename?: 'Asset', id: string | null, approval: AssetApprovalState | null, status: AssetStatus | null, sort: string | null, type: AssetType | null, name: string | null, image: string | null, parentId: string | null, categoryId: string | null, nextAssetId: string | null, prevAssetId: string | null, contentAmount: string | null, contentUnit: string | null, favorite: boolean | null, geometry: string | null, metashotsType: AssetMetashotsType | null, assetTypes: AssetTypes | null, brandId: string | null, collectionId: Array<string> | null, oderIndex: number | null, dateCreated: string | null, dateUpdated: string | null }> } };

export type GetCollectionAssetsQueryVariables = Exact<{
  collectionId: Scalars['String']['input'];
  query?: InputMaybe<CollectionAssetsQuery>;
}>;


export type GetCollectionAssetsQuery = { __typename?: 'Query', collectionAssets: { __typename?: 'CollectionAssetsQueryResult', limit: number | null, offset: number | null, page: number | null, totalCount: number, items: Array<{ __typename?: 'Asset', id: string | null, approval: AssetApprovalState | null, status: AssetStatus | null, sort: string | null, type: AssetType | null, name: string | null, image: string | null, parentId: string | null, categoryId: string | null, nextAssetId: string | null, prevAssetId: string | null, contentAmount: string | null, contentUnit: string | null, favorite: boolean | null, geometry: string | null, metashotsType: AssetMetashotsType | null, assetTypes: AssetTypes | null, brandId: string | null, collectionId: Array<string> | null, oderIndex: number | null, dateCreated: string | null, dateUpdated: string | null }> } };

export type GetCollectionQueryVariables = Exact<{
  collectionId: Scalars['String']['input'];
}>;


export type GetCollectionQuery = { __typename?: 'Query', collection: { __typename?: 'Collection', id: string, status: CollectionStatus | null, sort: string | null, name: string | null, image: string | null, userId: string | null, sharedUserIds: Array<string | null> | null, dateCreated: string | null, dateUpdated: string | null, createdBy: string | null, externalServiceConnections: Array<string | null> | null } };

export type GetCollectionsQueryVariables = Exact<{
  query?: InputMaybe<CollectionQuery>;
}>;


export type GetCollectionsQuery = { __typename?: 'Query', collections: { __typename?: 'CollectionQueryResult', items: Array<{ __typename?: 'Collection', id: string, status: CollectionStatus | null, sort: string | null, name: string | null, image: string | null, userId: string | null, sharedUserIds: Array<string | null> | null, dateCreated: string | null, dateUpdated: string | null, createdBy: string | null, externalServiceConnections: Array<string | null> | null }> } };

export type SharedCollectionsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  query?: InputMaybe<SharedCollectionQuery>;
}>;


export type SharedCollectionsQuery = { __typename?: 'Query', sharedCollections: { __typename?: 'SharedCollectionQueryResult', items: Array<{ __typename?: 'Collection', id: string, status: CollectionStatus | null, sort: string | null, name: string | null, image: string | null, userId: string | null, sharedUserIds: Array<string | null> | null, dateCreated: string | null, dateUpdated: string | null, createdBy: string | null }> } };

export type CommentsQueryVariables = Exact<{
  query?: InputMaybe<CommentQuery>;
}>;


export type CommentsQuery = { __typename?: 'Query', comments: { __typename?: 'CommentQueryResult', totalCount: number, limit: number | null, offset: number | null, page: number | null, items: Array<{ __typename?: 'Comment', id: string, userId: string, status: CommentStatus | null, sort: string | null, assetId: string | null, parentId: string | null, comment: string, dateCreated: string | null, dateUpdated: string | null }> } };

export type PublicSharedCollectionAccessTokenQueryVariables = Exact<{
  publicSharedCollectionAccessTokenId: Scalars['String']['input'];
}>;


export type PublicSharedCollectionAccessTokenQuery = { __typename?: 'Query', publicSharedCollectionAccessToken: { __typename?: 'PublicSharedCollectionAccessToken', suspended: boolean, startDate: string | null, id: string, expirationDate: string | null, createdBy: string | null, collectionId: string | null } };

export type PublicSharedCollectionAccessTokensQueryVariables = Exact<{
  query?: InputMaybe<PublicSharedCollectionQuery>;
}>;


export type PublicSharedCollectionAccessTokensQuery = { __typename?: 'Query', publicSharedCollectionAccessTokens: { __typename?: 'PublicSharedCollectionQueryResult', items: Array<{ __typename?: 'PublicSharedCollectionAccessToken', suspended: boolean, startDate: string | null, id: string, expirationDate: string | null, createdBy: string | null, collectionId: string | null }> } };

export type GetCollectionSyncLogAssetLogsQueryVariables = Exact<{
  collectionSyncLogId: Scalars['String']['input'];
}>;


export type GetCollectionSyncLogAssetLogsQuery = { __typename?: 'Query', collectionSyncLogAssetLogs: Array<{ __typename?: 'MetaphoreAssetSyncLog', id: string, status: MetaphoreAssetSyncLogStatus | null, asset: string | null, platform: string | null, server_response: string | null, dateCreated: string | null }> };

export type GetCollectionSyncLogsQueryVariables = Exact<{
  collectionId: Scalars['String']['input'];
  query?: InputMaybe<CollectionSyncLogsQuery>;
}>;


export type GetCollectionSyncLogsQuery = { __typename?: 'Query', collectionSyncLogs: { __typename?: 'CollectionSyncLogsQueryResult', limit: number | null, offset: number | null, page: number | null, totalCount: number, items: Array<{ __typename?: 'MetaphoreCollectionSyncLog', id: string, status: MetaphoreCollectionSyncLogStatus | null, triggerType: MetaphoreCollectionSyncLogTriggerType | null, scheduledAt: string | null, executedAt: string | null, dateCreated: string | null, dateUpdated: string | null, triggeredBy: string | null, triggeredByName: string | null, startedBy: string | null, canceledBy: string | null, canceledByName: string | null, errorLog: string | null, assets: Array<{ __typename?: 'MetaphoreCollectionSyncLogAsset', id: string, name: string | null, image: string | null, addedBy: string | null, addedByName: string | null, addedAt: string | null }> | null }> } };

export type GetBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrandsQuery = { __typename?: 'Query', brands: { __typename?: 'BrandQueryResult', items: Array<{ __typename?: 'Brand', name: string | null, sort: string | null, status: BrandStatus | null, id: string }> } };

export type GetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = { __typename?: 'Query', categories: { __typename?: 'CategoryQueryResult', items: Array<{ __typename?: 'Category', id: string, name: string | null, parentId: string | null, orderIndex: number | null }> } };

export type GetCategoryQueryVariables = Exact<{
  categoryId: Scalars['String']['input'];
}>;


export type GetCategoryQuery = { __typename?: 'Query', category: { __typename?: 'Category', id: string, name: string | null, parentId: string | null, orderIndex: number | null } };

export type LabelTypesQueryVariables = Exact<{
  query?: InputMaybe<LabelTypeQueryInput>;
}>;


export type LabelTypesQuery = { __typename?: 'Query', labelTypes: { __typename?: 'LabelTypeQueryResult', totalCount: number, limit: number | null, offset: number | null, page: number | null, items: Array<{ __typename?: 'LabelType', name: string, id: string }> } };

export type ItemsQueryVariables = Exact<{
  query?: InputMaybe<LanguageRegionQuery>;
}>;


export type ItemsQuery = { __typename?: 'Query', languageRegions: { __typename?: 'LanguageRegionQueryResult', items: Array<{ __typename?: 'LanguageRegion', id: string, status: LanguageRegionStatus | null, name: string | null, sort: string | null, dateCreated: string | null, dateUpdated: string | null }> } };

export type ProductTypesQueryVariables = Exact<{
  query?: InputMaybe<ProductTypeQueryInput>;
}>;


export type ProductTypesQuery = { __typename?: 'Query', productTypes: { __typename?: 'ProductTypeQueryResult', totalCount: number, page: number | null, offset: number | null, limit: number | null, items: Array<{ __typename?: 'ProductType', name: string, id: string }> } };

export type TypeOfShotsQueryVariables = Exact<{
  query?: InputMaybe<TypeOfShotQueryInput>;
}>;


export type TypeOfShotsQuery = { __typename?: 'Query', typeOfShots: { __typename?: 'TypeOfShotQueryResult', totalCount: number, limit: number | null, offset: number | null, page: number | null, items: Array<{ __typename?: 'TypeOfShot', name: string, id: string }> } };

export type GetUserPoolUsersQueryVariables = Exact<{
  query?: InputMaybe<UserPoolQuery>;
}>;


export type GetUserPoolUsersQuery = { __typename?: 'Query', userPoolUsers: { __typename?: 'UserPoolQueryResult', totalCount: number, limit: number | null, offset: number | null, page: number | null, items: Array<{ __typename?: 'UserPoolUser', id: string }> } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', email: string | null, isAdmin: boolean | null, name: string | null, permissions: Array<string> | null, username: string | null, id: string, groups: Array<string> | null, activeClientId: string | null, clientIds: Array<string> | null, clients: Array<{ __typename?: 'Client', id: string, name: string }> | null } | null };

export type ItemsUsersQueryVariables = Exact<{
  input?: InputMaybe<UserQueryInput>;
}>;


export type ItemsUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserQueryResult', totalCount: number, items: Array<{ __typename?: 'IAMUser', lastname: string | null, id: string | null, firstname: string | null, email: string | null }> } };

export type GetLatestCollectionSyncLogQueryVariables = Exact<{
  getLatestCollectionSyncLogId: Scalars['String']['input'];
}>;


export type GetLatestCollectionSyncLogQuery = { __typename?: 'Query', getLatestCollectionSyncLog: { __typename?: 'MetaphoreCollectionSyncLogResult', item: { __typename?: 'MetaphoreCollectionSyncLog', status: MetaphoreCollectionSyncLogStatus | null, id: string, assetIds: Array<string | null> | null, dateCreated: string | null } | null } | null };


export const BrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Brands"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<BrandsQuery, BrandsQueryVariables>;
export const SubsidiariesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Subsidiaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subsidiaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SubsidiariesQuery, SubsidiariesQueryVariables>;
export const SyncCollectionAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncCollectionAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SyncCollectionAssetsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncCollectionAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SyncCollectionAssetsMutation, SyncCollectionAssetsMutationVariables>;
export const UpdateAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateAssetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateAssetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approval"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"nextAssetId"}},{"kind":"Field","name":{"kind":"Name","value":"prevAssetId"}},{"kind":"Field","name":{"kind":"Name","value":"contentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"contentUnit"}},{"kind":"Field","name":{"kind":"Name","value":"favorite"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"metashotsType"}},{"kind":"Field","name":{"kind":"Name","value":"languageRegionsId"}},{"kind":"Field","name":{"kind":"Name","value":"assetTypes"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"oderIndex"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"masterId"}},{"kind":"Field","name":{"kind":"Name","value":"adaptionId"}}]}}]}}]} as unknown as DocumentNode<UpdateAssetMutation, UpdateAssetMutationVariables>;
export const BatchArchiveAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BatchArchiveAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchArchiveAssetsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchArchiveAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<BatchArchiveAssetsMutation, BatchArchiveAssetsMutationVariables>;
export const DeleteAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteAssetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteAssetId"}}}]}]}}]} as unknown as DocumentNode<DeleteAssetMutation, DeleteAssetMutationVariables>;
export const DeleteCollectionAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCollectionAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCollectionAssetsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCollectionAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeleteCollectionAssetsMutation, DeleteCollectionAssetsMutationVariables>;
export const CreateCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"orderIndex"}}]}}]}}]} as unknown as DocumentNode<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateCategoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateCategoryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"orderIndex"}}]}}]}}]} as unknown as DocumentNode<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const CreateCollectionAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCollectionAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCollectionAssetsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCollectionAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateCollectionAssetsMutation, CreateCollectionAssetsMutationVariables>;
export const BatchCreateCollectionAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BatchCreateCollectionAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchCreateCollectionAssetsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchCreateCollectionAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<BatchCreateCollectionAssetsMutation, BatchCreateCollectionAssetsMutationVariables>;
export const DeleteCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteCollectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteCollectionId"}}}]}]}}]} as unknown as DocumentNode<DeleteCollectionMutation, DeleteCollectionMutationVariables>;
export const UpdateCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateCollectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateCollectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"sharedUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}}]}}]}}]} as unknown as DocumentNode<UpdateCollectionMutation, UpdateCollectionMutationVariables>;
export const UpdateCollectionThumbnailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCollectionThumbnail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCollectionThumbnailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCollectionThumbnail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateCollectionThumbnailMutation, UpdateCollectionThumbnailMutationVariables>;
export const CreateCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"sharedUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}}]}}]}}]} as unknown as DocumentNode<CreateCollectionMutation, CreateCollectionMutationVariables>;
export const ShareCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShareCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ShareCollectionMutation, ShareCollectionMutationVariables>;
export const CreateCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}}]}}]}}]} as unknown as DocumentNode<CreateCommentMutation, CreateCommentMutationVariables>;
export const DeleteCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteCommentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteCommentId"}}}]}]}}]} as unknown as DocumentNode<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const UpdateCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateCommentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateCommentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}}]}}]}}]} as unknown as DocumentNode<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const CreatePublicSharedCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePublicSharedCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePublicSharedCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPublicSharedCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suspended"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}}]}}]}}]} as unknown as DocumentNode<CreatePublicSharedCollectionMutation, CreatePublicSharedCollectionMutationVariables>;
export const DeletePublicSharedCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePublicSharedCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletePublicSharedCollectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePublicSharedCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletePublicSharedCollectionId"}}}]}]}}]} as unknown as DocumentNode<DeletePublicSharedCollectionMutation, DeletePublicSharedCollectionMutationVariables>;
export const CancelScheduledCollectionSyncDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelScheduledCollectionSync"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelScheduledCollectionSync"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"canceledBy"}},{"kind":"Field","name":{"kind":"Name","value":"canceledByName"}}]}}]}}]} as unknown as DocumentNode<CancelScheduledCollectionSyncMutation, CancelScheduledCollectionSyncMutationVariables>;
export const RunScheduledCollectionSyncNowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RunScheduledCollectionSyncNow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runScheduledCollectionSyncNow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"executedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedBy"}}]}}]}}]} as unknown as DocumentNode<RunScheduledCollectionSyncNowMutation, RunScheduledCollectionSyncNowMutationVariables>;
export const MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAssetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAsset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MutationMutation, MutationMutationVariables>;
export const GetAssetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAsset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approval"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"nextAssetId"}},{"kind":"Field","name":{"kind":"Name","value":"prevAssetId"}},{"kind":"Field","name":{"kind":"Name","value":"contentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"contentUnit"}},{"kind":"Field","name":{"kind":"Name","value":"favorite"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"metashotsType"}},{"kind":"Field","name":{"kind":"Name","value":"assetTypes"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"oderIndex"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"adaptionId"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"masterId"}},{"kind":"Field","name":{"kind":"Name","value":"productType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"labelType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"typeOfShot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetAssetQuery, GetAssetQueryVariables>;
export const GetAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approval"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"nextAssetId"}},{"kind":"Field","name":{"kind":"Name","value":"prevAssetId"}},{"kind":"Field","name":{"kind":"Name","value":"contentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"contentUnit"}},{"kind":"Field","name":{"kind":"Name","value":"favorite"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"metashotsType"}},{"kind":"Field","name":{"kind":"Name","value":"assetTypes"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"oderIndex"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}}]}}]}}]} as unknown as DocumentNode<GetAssetsQuery, GetAssetsQueryVariables>;
export const GetCollectionAssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCollectionAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionAssetsQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approval"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"nextAssetId"}},{"kind":"Field","name":{"kind":"Name","value":"prevAssetId"}},{"kind":"Field","name":{"kind":"Name","value":"contentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"contentUnit"}},{"kind":"Field","name":{"kind":"Name","value":"favorite"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"metashotsType"}},{"kind":"Field","name":{"kind":"Name","value":"assetTypes"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"oderIndex"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetCollectionAssetsQuery, GetCollectionAssetsQueryVariables>;
export const GetCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"sharedUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"externalServiceConnections"}}]}}]}}]} as unknown as DocumentNode<GetCollectionQuery, GetCollectionQueryVariables>;
export const GetCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCollections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"sharedUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"externalServiceConnections"}}]}}]}}]}}]} as unknown as DocumentNode<GetCollectionsQuery, GetCollectionsQueryVariables>;
export const SharedCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SharedCollections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SharedCollectionQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sharedCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"sharedUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}}]}}]}}]}}]} as unknown as DocumentNode<SharedCollectionsQuery, SharedCollectionsQueryVariables>;
export const CommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Comments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}}]} as unknown as DocumentNode<CommentsQuery, CommentsQueryVariables>;
export const PublicSharedCollectionAccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicSharedCollectionAccessToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publicSharedCollectionAccessTokenId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicSharedCollectionAccessToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publicSharedCollectionAccessTokenId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suspended"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}}]}}]}}]} as unknown as DocumentNode<PublicSharedCollectionAccessTokenQuery, PublicSharedCollectionAccessTokenQueryVariables>;
export const PublicSharedCollectionAccessTokensDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicSharedCollectionAccessTokens"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PublicSharedCollectionQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicSharedCollectionAccessTokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suspended"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}}]}}]}}]}}]} as unknown as DocumentNode<PublicSharedCollectionAccessTokensQuery, PublicSharedCollectionAccessTokensQueryVariables>;
export const GetCollectionSyncLogAssetLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCollectionSyncLogAssetLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionSyncLogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionSyncLogAssetLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionSyncLogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionSyncLogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","name":{"kind":"Name","value":"server_response"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}}]}}]}}]} as unknown as DocumentNode<GetCollectionSyncLogAssetLogsQuery, GetCollectionSyncLogAssetLogsQueryVariables>;
export const GetCollectionSyncLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCollectionSyncLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionSyncLogsQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionSyncLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"triggerType"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}},{"kind":"Field","name":{"kind":"Name","value":"executedAt"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"triggeredBy"}},{"kind":"Field","name":{"kind":"Name","value":"triggeredByName"}},{"kind":"Field","name":{"kind":"Name","value":"startedBy"}},{"kind":"Field","name":{"kind":"Name","value":"canceledBy"}},{"kind":"Field","name":{"kind":"Name","value":"canceledByName"}},{"kind":"Field","name":{"kind":"Name","value":"errorLog"}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"addedBy"}},{"kind":"Field","name":{"kind":"Name","value":"addedByName"}},{"kind":"Field","name":{"kind":"Name","value":"addedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetCollectionSyncLogsQuery, GetCollectionSyncLogsQueryVariables>;
export const GetBrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetBrandsQuery, GetBrandsQueryVariables>;
export const GetCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"orderIndex"}}]}}]}}]}}]} as unknown as DocumentNode<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"orderIndex"}}]}}]}}]} as unknown as DocumentNode<GetCategoryQuery, GetCategoryQueryVariables>;
export const LabelTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LabelTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LabelTypeQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"labelTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}}]} as unknown as DocumentNode<LabelTypesQuery, LabelTypesQueryVariables>;
export const ItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Items"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageRegionQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languageRegions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}},{"kind":"Field","name":{"kind":"Name","value":"dateUpdated"}}]}}]}}]}}]} as unknown as DocumentNode<ItemsQuery, ItemsQueryVariables>;
export const ProductTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTypeQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}}]}}]} as unknown as DocumentNode<ProductTypesQuery, ProductTypesQueryVariables>;
export const TypeOfShotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TypeOfShots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TypeOfShotQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"typeOfShots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}}]} as unknown as DocumentNode<TypeOfShotsQuery, TypeOfShotsQueryVariables>;
export const GetUserPoolUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserPoolUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserPoolQuery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userPoolUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}}]} as unknown as DocumentNode<GetUserPoolUsersQuery, GetUserPoolUsersQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"}},{"kind":"Field","name":{"kind":"Name","value":"activeClientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientIds"}},{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const ItemsUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ItemsUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserQueryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ItemsUsersQuery, ItemsUsersQueryVariables>;
export const GetLatestCollectionSyncLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestCollectionSyncLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getLatestCollectionSyncLogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLatestCollectionSyncLog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getLatestCollectionSyncLogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetIds"}},{"kind":"Field","name":{"kind":"Name","value":"dateCreated"}}]}}]}}]}}]} as unknown as DocumentNode<GetLatestCollectionSyncLogQuery, GetLatestCollectionSyncLogQueryVariables>;